import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  name: false,
  surname: false,
  email: false,
  phone: false,
  isCardComplete: false,

  link: false,
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.NAME_SET:
      return state.merge({
        name: action.value
      });
    case types.SURNAME_SET:
      return state.merge({
        surname: action.value
      });
    case types.EMAIL_SET:
      return state.merge({
        email: action.value
      });
    case types.PHONE_SET:
      return state.merge({
        phone: action.value
      });
    case types.CARD_COMPLETE_SET:
      return state.merge({
        isCardComplete: action.value
      });
    case types.LINK_SET:
      return state.merge({
        link: action.value
      });
    default:
      return state;
  }
}

// selectors
export function getName(state) {
  return state.checkout.name;
}

export function getSurname(state) {
  return state.checkout.surname;
}

export function getEmail(state) {
  return state.checkout.email;
}

export function getPhone(state) {
  return state.checkout.phone;
}

export function getIsCardComplete(state) {
  return state.checkout.isCardComplete;
}

export function getLink(state) {
  return state.checkout.link;
}